<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">    
  	  <div class="backborder3" style="padding:1% 1% 1% 1%">
          <div class="statout" style="background:#F56C6C;">
          	  <img src="../../static/images/getmoney.png"/>
          	  <span class="number">{{paycustomernumber}}</span>
          	  <span class="desc">应付供应商（家）</span>
          </div>
          <div class="statout" style="background:#E6A23C;">
          	  <img src="../../static/images/getallmoney.png"/>
          	  <span class="number">{{paymoney.money}}</span>
          	  <span class="desc">应付合计（{{paymoney.unit}}）</span>
          </div>
          <div class="statout" style="background:#67C23A;">
          	  <img src="../../static/images/customers.png"/>
          	  <span class="number"><a href="javascript:;" @click="getAllcustomers">{{allcustomernumber}}</a></span>
          	  <span class="desc">供应商总数（家）</span>
          </div>	
      </div>
    
      <!------------------------search---------------------->
      <el-form :inline="true" class="backborder3 demo-form-inline" size="small" style="margin-top:10px;padding-bottom:0">
      	  <el-form-item style="width:10%">
      	  	  <el-select v-model="query.applyid" filterable clearable  @change="orderisselect=true" style="width:100%">
		          <el-option v-for="(item,index) in allapplylists" :key="index" :label="item.apply_name" :value="item.id"></el-option>
		      </el-select> 
      	  </el-form-item>
    	  <el-form-item style="width:21%">
			  <el-date-picker v-model="query.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="orderisselect=true" style="width:100%"></el-date-picker>	
		  </el-form-item> 
          <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
          </el-form-item>
      </el-form>
      <!------------------------search end---------------------->
      
      <div class="backborder3" style="margin:10px 0 2% 0">
	      <el-table :data="lists" v-loading="listLoading">
	      	  <el-table-column prop="name" label="供应商名称"></el-table-column>
	          <el-table-column prop="total" label="应收款合计" width="180" align="center"></el-table-column>
	      </el-table>
	      <div class="block">
	          <!--分页begin-->
	          <el-pagination
	              @size-change="pageSizeChange"
	              @current-change="pageCurrentChange"
	              :current-page="query.p"
	              :page-sizes="[10, 20, 50 ,1000]"
	              :page-size="query.rollpage"
	              layout="total, sizes, prev, pager, next, jumper"
	              :total="total_rows">
	          </el-pagination>
	          <!--分页end-->
	      </div>
      </div>

      
      
  </div>
  </transition>
</template>

<script>

export default {
  data () {
    return {
      actionauth:'', //操作权限
      transitionshow:true,
      url:this.GLOBAL.domain+"Customer/index",
      allapplylists:[],
      lists:[],
      listLoading:false,
      query:{
        act:'applycollection',
        token:this.$cookies.get('token'),
        applyid:'',
        date:'',
        rollpage: 10, // 页大小
        p: 1
      },
      total_rows: 0,
      paycustomernumber:0,
      allcustomernumber:0,
      paymoney: {
      	  unit:'',
      	  money:0.00,
      },
      orderDialog:false,
      orderlists:[],
      orderListLoading:false,
      orderquery:{
        act:'getpayorder',
        token:this.$cookies.get('token'),
        date:'',
        type:'',
        id:'',
        rollpage: 10, // 页大小
        p: 1
      },
      total_order_rows: 0,
      settleDialog:false,
      accountLists:[],
      settle:{
        act:'settle',
        token:this.$cookies.get('token'),
        total:'',
        account:'',
        id:''
      },
      settleLoading:false,
      jsDialog:false,
      showname:'',
      addProductLoading:false,
      multipleSelection:[],
      sellids:'',
      totals:'',
      showordertotalDialog:false,
      addpayLoading:false,
      orderisselect:false,
      customerLists:[],
      customerLoading:false,
      sellerLists:[],
      typelists:[
      	  {id:1,name:'按客户'},
      	  {id:2,name:'按销售员'},
      ],
      orderlistsstatus:[],
      orderselectids:[],
      settlemoreLoading:false,
      settlemoreDialog:false,
      settlemore:{
      	  ids:'',
      	  act:'savesettlemore',
      	  token:this.$cookies.get('token'),
      	  derate:0.00,
      	  payamount:0.00,
      	  account:'',
      },
    }
  },
  mounted(){
    this.getList();
    this.getactionauth();
    this.getAccount(); //获取支付账号
    this.getSeller(); //获取销售员列表
    this.getAllapplylists(); //获取供应商列表
  },
  
  methods:{
  
    /** 获取操作权限 **/
    getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
    
    /** 获取全部供应商列表 **/
    getAllapplylists() {
        var resource = this.$resource(this.GLOBAL.domain+"Product/index");
        resource.query({act:'getapplyAll',token:this.$cookies.get('token')}).then((res) => {
        	if(res.data.Result>0){
            	if(res.data.Result=='70001') this.$router.push('/login');
                this.$message.error(res.data.Message);;
            }else{
				this.allapplylists=JSON.parse(Base64.decode(res.data.Data));
            }
        }).catch((res) => {
        	this.$message.error(this.GLOBAL.errortext);
        });
    },
  
  
    /** 信息列表 **/
    getList(){
    	if(this.orderisselect==true) {
    		this.query.p=1;
    		this.query.rollpage=10;
    	}
    
        this.listLoading = true;
        var resource = this.$resource(this.url);
        resource.query(this.query).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.listLoading = false;
	        }else{
	            var result = JSON.parse(Base64.decode(res.data.Data));
	            this.lists = result.lists;
	            this.paycustomernumber=result.paycount;
	            this.allcustomernumber=result.allnums;
	            this.paymoney.unit=result.paymoney.unit;
	            this.paymoney.money=result.paymoney.amount;
	            this.total_rows=parseInt(res.data.count);
	            this.listLoading = false;
	            if(this.orderisselect==true) this.orderisselect=false;
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.listLoading=false;
        });
    },
    pageSizeChange(val) {
        this.query.rollpage = val;
        this.getList();
    },
    pageCurrentChange(val) {
        this.query.p = val;
        this.getList();
    },
    
    
    /** 应付账款详情 **/
    showOrder(item){
        this.orderquery.id=item.id;
        this.orderquery.type=this.query.type;
        this.orderquery.date=this.query.date;
        this.orderquery.p=1;
        this.orderquery.rollpage=10;
        this.orderDialog=true;
        this.getOrderList();
    },
    
    
    /** 未结算的订单列表 **/
    getOrderList(){
        this.orderListLoading = true;
        var resource = this.$resource(this.url);
        resource.query(this.orderquery).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.orderListLoading = false;
	        }else{
	            this.orderlists = JSON.parse(Base64.decode(res.data.Data));
	            this.total_order_rows=parseInt(res.data.count);
	            this.orderListLoading = false;
	            
	            //清空选中的订单,并往里写入如选中订单状态为未选中
                var _this=this;
                this.orderlistsstatus=[];
                this.orderselectids=[];
                this.orderlists.forEach(function(item,i) {
                	_this.orderlistsstatus.push(0);
                });
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.orderListLoading=false;
        });
    },
    orderPageSizeChange(val) {
        this.orderquery.rollpage = val;
        this.getOrderList();
    },
    orderPageCurrentChange(val) {
        this.orderquery.p = val;
        this.getOrderList();
    },
    
    
    /** 获取银行帐户 **/
    getAccount(){
        var resource = this.$resource(this.GLOBAL.domain+"Account/index");
        resource.query({act:'lists',isdeposit:1,token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.accountLists = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    /** 获取客户 **/
    getCustomer(query){
        if (query !== '') {
	        this.customerLoading = true;
	        var resource = this.$resource(this.GLOBAL.domain+"Customer/index");
	        resource.query({act:'lists',key:query,token:this.$cookies.get('token')}).then((res) => {
	            if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.customerLoading = false;
	            }else{
		            this.customerLists = JSON.parse(Base64.decode(res.data.Data));
		            this.customerLoading = false;
	            }
	        }).catch((res) => {
	            //this.$message.error(this.GLOBAL.errortext);
	            this.customerLoading = false;
	        });
        }
    },
    
    
    /** 获取销售员 **/
    getSeller(){
        var resource = this.$resource(this.GLOBAL.domain+"Clerk/index");
        resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.sellerLists = JSON.parse(Base64.decode(res.data.Data));	                      
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    
    /** 获取结算订单列表 **/
    settleCurrent(item){   
    	this.getorderquery.customerid=item.id;
    	this.showname=item.name+'的未结算订单';
      	this.getOrderList();
      	this.jsDialog=true;
    },
    
    settleSave(){
        this.settleLoading=true;
        var resource = this.$resource(this.url);
        resource.save(this.settle).then((res) => {
            if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.settleLoading=false;
            }else{
	            this.$message.success("订单批量结算成功");
	            this.settleDialog=false;
	            this.settleLoading=false;
	            this.orderDialog=false;
	            this.getList();
            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.settleDialog=false;
            this.settleLoading=false;
        });
    },
    
    //单行点击触发
    selectorder(row) {       	
    	var _this=this;
    	var number=this.orderselectids.indexOf(row.id);
    	number==-1 ? this.orderselectids.push(row.id) : this.orderselectids.splice(number,1);  	
    	
    	this.orderlists.forEach(function(item,i) { //更新商品的状态
    		//勾选/取消勾选订单
    		if(item.id==row.id) _this.$refs.multipleTable.toggleRowSelection(_this.orderlists[i]);
    	
			//查询订单id在选中的数组里是否存在
			if(_this.orderselectids.indexOf(item.id)!=-1) {
				_this.orderlistsstatus[i]=1;
			}else {
				_this.orderlistsstatus[i]=0;
			}
			
		});  	
    },
    
    //订单列表选择有变动时触发
    handleSelectionChange(val) {
    	var _this=this;
    	this.orderselectids=[]; //清空获取的订单id
		val.forEach(function(item,i) {_this.orderselectids.push(item.id);}); //获取已选中的订单id
		this.orderlists.forEach(function(item,i) { //更新商品的状态
			//查询订单id在选中的数组里是否存在
			if(_this.orderselectids.indexOf(item.id)!=-1) {
				_this.orderlistsstatus[i]=1;
			}else {
				_this.orderlistsstatus[i]=0;
			}
			
		});   	
    	
    },
    
    
    /** 保存结算 **/
    savepay() {
    	if(this.multipleSelection.length==0) {this.$message.error("请选择要结算的订单");return false;}
    	this.addProductLoading=true;
    	
    	var resource = this.$resource(this.url);
      	resource.save({act:'getpaymessage',param:this.multipleSelection,token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.addProductLoading=false;
            }else{
	            var result = JSON.parse(Base64.decode(res.data.Data));
	            this.settle.total=result.totals;
	            this.settle.id=result.ids;
	            this.settle.account='';
	            this.addProductLoading=false;
	            this.showordertotalDialog=true;
            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.addProductLoading=false;
        });
    },
    
    
    /** 结算 **/
    addpay() {
    	if(this.settlemore.account=='') {this.$message.error("请选择支付方式");return false;}
    	this.addpayLoading=true;
    	
    	var resource = this.$resource(this.url);
        resource.save(this.settlemore).then((res) => {
            if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.addpayLoading=false;
            }else{
	            this.$message.success("批量结算订单成功");
	            this.addpayLoading=false;
	            this.settlemoreDialog=false;
	            this.orderDialog=false;
	            this.getList();
            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.addpayLoading=false;
        });
    },
    
    
    //获取订单批量结算信息
    settlemoreSave() { 
    	if(this.orderselectids.length==0) {this.$message.error("请选择要结算的订单");return false;}
    	if(this.orderselectids.length > 10) {this.$message.error("请不要单次结算超过10个订单");return false;}
    
    	this.settlemoreLoading=true;
    	var resource = this.$resource(this.url);
        resource.save({act:'getmoreamount',token:this.$cookies.get('token'),ids:this.orderselectids}).then((res) => {
            if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.settlemoreLoading=false;
            }else{
            	var result = JSON.parse(Base64.decode(res.data.Data));
            	this.settlemore.ids=this.orderselectids;
            	this.settlemore.payamount=result;
            	this.settlemore.derate=0.00;
            	this.settlemore.account='';
	            this.settlemoreLoading=false;
	            this.settlemoreDialog=true;    
            }
        }).catch((res) => {
            this.settlemoreLoading=false;
        });
    },
    
    
    //修改结算优惠金额
    changederate() {
    	if(this.settlemore.derate > this.settlemore.payamount) {
    		this.$message.error("优惠金额不能大于结算总额");
    		this.settlemore.derate=0.00;
    		return false;
    	}
    	
    	var pay=this.settlemore.payamount;
    	this.settlemore.payamount=(pay-this.settlemore.derate).toFixed(2);
    },
    
    /** 点击客户总数 **/
    getAllcustomers() {
    	this.$emit('listenchild',{name:'客户管理',url:'Customer'});
    },
    
    
  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.backborder3 {background:#fff;border-radius:15px;border:1px solid #ddd;float:left;width:98%;padding:1% 1% 1% 1%;}
.statout {position:relative;width:20%;height:5%;margin-right:2%;float:left;border:1px solid #E4E7ED;border-radius:5px}
.statout img {float:left;width:24%;padding:6% 5%}
.statout .number {float:left;width:61%;padding-left:5%;margin-top:8%;color:#fff;font-weight:bold;font-size:20px;}
.statout .number a {text-decoration:underline;color:#fff}
.statout .desc {float:left;width:61%;padding-left:5%;margin-top:0;color:#fff;font-size:14px;}
</style>


// WEBPACK FOOTER //
// src/components/base/ApplyCollection.vue